const  MobileInterface =  {
  

  openLink(url) {
    
    if(window.MobileInterface) {
      //use android interface
      window.MobileInterface.openLink(url)
    } else {
      //try ios interface
      try {
        window.webkit.messageHandlers.openLink.postMessage(url);
      } catch (error) {
        //fallback
        //erro
      }
    }
  },

  setOneSignalExternalUserId(id) {
    
    if(window.MobileInterface) {
      //use android interface
      window.MobileInterface.setOneSignalExternalUserId(id);
    } else {
      //try ios interface
      try {
        window.webkit.messageHandlers.setOneSignalExternalUserId.postMessage(id);
      } catch (error) {
        //fallback
        //erro
      }
    }
  },

  playSound(item) {
    if(window.MobileInterface) {
      //use android interface
      window.MobileInterface.playSound(item)
    } else {
      //try ios interface
      try {
        window.webkit.messageHandlers.playSound.postMessage(item);
      } catch (error) {
        //error
      }
    }
  },

  shareApp() {
    if(window.MobileInterface) {
      window.MobileInterface.shareApp();
    } else {
      try {
        window.webkit.messageHandlers.shareApp.postMessage();
      } catch (error) {
        //..error
      }
    }
  },

  rateApp() {
    if(window.MobileInterface) {
      window.MobileInterface.openLink('https://play.google.com/store/apps/details?id=com.soldrax.soldrax&reviewId=0');

    } else {
      try {
        //handle ios logic for sharing app
      } catch (error) {
        
      }
    }
  },
}

export default MobileInterface;